export default {
  title: 'Pagar com {{method}}',
  hint: 'Toque no botão abaixo e aprove o pagamento na janela do {{method}}.',
  confirming: 'A confirmar o seu pagamento…',
  cancel: 'Cancelar pagamento',
  unavailable: 'Este método de pagamento não está disponível de momento. Escolha outro.',
  approval_timeout:
    'Não recebemos resposta de {{method}}. Se a janela não abriu, verifique se os pop-ups estão permitidos, depois tente novamente ou escolha outro método de pagamento.',
};
